import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Пазл размером 274x304мм состоит из 210 элементов. Представлен в горизонтальном и вертикальном форматах. Допускает печать разных файлов и изображений (jpg, tiff, psd, cdr, eps) с минимально допустимым разрешением 300 dpi.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
